import {
    LOGIN,
    SET_USER,
    SET_SHIFT,
    LOGOUT,
    CODE_BLUE,
    SET_PARAMS,
    ADD_ORDER_ITEM,
    MODIFY_ORDER_ITEM,
    REMOVE_ORDER_ITEM,
    CLEAR_ORDER,
    ADD_ACC_ITEM,
    MODIFY_ACC_ITEM,
    REMOVE_ACC_ITEM,
    CLEAR_ACC_QUEUE,
    INVENTORY_ALERT,
} from './actionTypes'

// Auth
export const login = token => ({
    type: LOGIN,
    token
})

export const setuser = user => ({
    type: SET_USER,
    user
})

export const logout = () => ({
    type: LOGOUT
})

// Shift
export const setShift = shift => ({
    type: SET_SHIFT,
    shift
})

// Organization
export const setparams = params => ({
    type: SET_PARAMS,
    params
})

export const setCodeBlue = data => ({
    type: CODE_BLUE,
    data
})

export const setInventoryAlert = data => ({
    type: INVENTORY_ALERT,
    data
})

// Order
export const addOrderItem = (variant, item) => ({
    type: ADD_ORDER_ITEM,
    variant,
    item
})

export const modifyOrderItem = (index, qty, price) => {
    return {
        type: MODIFY_ORDER_ITEM,
        index,
        qty,
        price
    }
}

export const removeOrderItem = index => ({
    type: REMOVE_ORDER_ITEM,
    index
})

export const clearOrder = () => ({
    type: CLEAR_ORDER
})

// Accounting
export const addItemToAccQueue = (item, price) => ({
    type: ADD_ACC_ITEM,
    item,
    price
})

export const modifyAccItem = (index, bulk, contains, price, vat, discount) => {
    return {
        type: MODIFY_ACC_ITEM,
        index,
        bulk,
        contains,
        price,
        vat,
        discount
    }
}

export const removeAccItem = index => ({
    type: REMOVE_ACC_ITEM,
    index
})

export const clearAccQueue = () => ({
    type: CLEAR_ACC_QUEUE
})
